import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4701c818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

import { computed, onMounted, ref } from "vue";
import { useStore } from "@/store";
import { MutationType } from "@/models/storeModel";
import { IInputMethods } from "@/models/inputModel";
import Input from "./components/Input.vue";
import Dropzone from "./components/Dropzone.vue";
import Download from "./components/Download.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const img = computed(() => store.state.imgUrl);
const wrapper = ref<HTMLDivElement | null>(null);
const input = ref<IInputMethods | null>(null);
const canvas = ref<HTMLCanvasElement | null>(null);
const ctx = ref<CanvasRenderingContext2D | null>(null);
const isDrawing = ref<boolean>(false);

let multipleX = 1;
let multipleY = 1;

let wrapperX = 1080;
let wrapperY = 839;

onMounted(() => {
  if (wrapper.value) {
    wrapperX = wrapper.value.clientWidth;
    wrapperY = wrapper.value.clientHeight;
  }
});

const wrapImageInCanvas = (file: Blob) => {
  const image = new Image();
  image.src = URL.createObjectURL(file);
  image.onload = function () {
    if (canvas.value) {
      if (image.width > wrapperX && image.height > wrapperY) {
        if (image.width > image.height) {
          multipleX = image.width / wrapperX;
          multipleY = wrapperY / (wrapperY / (image.width / wrapperX));
        } else {
          multipleX = wrapperX / (wrapperX / (image.height / wrapperY));
          multipleY = image.height / wrapperY;
        }
      }
      canvas.value.width = image.width;
      canvas.value.height = image.height;
      ctx.value = canvas.value.getContext("2d");
      if (ctx.value) {
        ctx.value.drawImage(image, 0, 0);
        ctx.value.lineCap = "round";
        ctx.value.strokeStyle = "red";
        ctx.value.lineWidth = 10;
      }
    }
  };
};

document.onpaste = (e: ClipboardEvent) => {
  const data = e.clipboardData || (window as any).clipboardData;
  const file = data.files[0];
  store.commit(MutationType.SetImage, file);
  wrapImageInCanvas(file);
};

document.oncopy = () => {
  if (canvas.value) {
    canvas.value.toBlob((blob: Blob | null) => {
      blob !== null && navigator.clipboard.write([
        new window.ClipboardItem({
          [blob.type]: blob
        })
      ]);
    });
  }
};

const startDrawing = (event: MouseEvent | TouchEvent) => {
  if (ctx.value) {
    isDrawing.value = true;
    if (event instanceof MouseEvent) {
      const { offsetX, offsetY } = event;
      ctx.value.beginPath();
      ctx.value.moveTo(offsetX * multipleX, offsetY * multipleY);
    }
    if (event instanceof TouchEvent) {
      const { pageX, pageY } = event.changedTouches[0];
      ctx.value.beginPath();
      ctx.value.moveTo(pageX * multipleX, pageY * multipleY);
    }
  }
};

const drawing = (event: MouseEvent | TouchEvent) => {
  if (!isDrawing.value) {
    return;
  }
  if (ctx.value) {
    if (event instanceof MouseEvent) {
      const { offsetX, offsetY } = event;
      ctx.value.lineTo(offsetX * multipleX, offsetY * multipleY);
      ctx.value.stroke();
    }
    if (event instanceof TouchEvent) {
      const { pageX, pageY } = event.changedTouches[0];
      ctx.value.lineTo(pageX * multipleX, pageY * multipleY);
      ctx.value.stroke();
    }
  }
};

const finishDrawing = () => {
  if (ctx.value) {
    ctx.value.closePath();
    isDrawing.value = false;
  }
};

const downloadCanvas = () => {
  if (canvas.value) {
    const link = document.createElement("a");
    link.href = canvas.value.toDataURL();
    link.setAttribute("visibility", "hidden");
    link.download = "image.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const handlers = {
  handleInput: (event: Event) => input.value && input.value.handleInput(event),
  triggerInput: () => input.value && input.value.triggerInput(),
  handleDrop: (event: DragEvent) => input.value && input.value.handleDrop(event),
  handleDragOver: (event: DragEvent) => input.value && input.value.handleDragOver(event),
  handleDragEnter: (event: DragEvent) => input.value && input.value.handleDragEnter(event),
  handleDragLeave: (event: DragEvent) => input.value && input.value.handleDragLeave(event),
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createVNode(Dropzone, {
        onClick: handlers.triggerInput,
        onDrop: handlers.handleDrop,
        onDragover: handlers.handleDragOver,
        onDragenter: handlers.handleDragEnter,
        onDragleave: handlers.handleDragLeave
      }, null, 8, ["onClick", "onDrop", "onDragover", "onDragenter", "onDragleave"]),
      _createVNode(Download, { onDownloadCanvas: downloadCanvas }),
      _createVNode(Input, {
        ref_key: "input",
        ref: input,
        onWrapImageInCanvas: wrapImageInCanvas
      }, null, 512)
    ]),
    _createElementVNode("div", {
      class: "wrapper",
      ref_key: "wrapper",
      ref: wrapper
    }, [
      (!_unref(img))
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "Image not added"))
        : _createCommentVNode("", true),
      (_unref(img))
        ? (_openBlock(), _createElementBlock("canvas", {
            key: 1,
            class: "canvas",
            ref_key: "canvas",
            ref: canvas,
            onMousedown: startDrawing,
            onMouseup: finishDrawing,
            onMousemove: drawing,
            onTouchstart: startDrawing,
            onTouchend: finishDrawing,
            onTouchmove: drawing
          }, null, 544))
        : _createCommentVNode("", true)
    ], 512)
  ], 64))
}
}

})